import React, { PureComponent } from 'react';
import {
  AppBar,
  Badge,
  Box,
  Button,
  ButtonGroup,
  IconButton,
  Toolbar,
  withStyles,
  withWidth
} from '@material-ui/core';
import { FiSearch, FiStar } from 'react-icons/fi';
import { IoSchoolOutline } from 'react-icons/io5';
import PropTypes from 'prop-types';
import { compose } from 'recompose';

const styles = (theme) => ({
  root: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: '#272A2D',
    borderBottomColor: '#9AC802',
    borderBottomWidth: '2px',
    borderBottomStyle: 'solid'
  },
  button: {
    marginRight: theme.spacing(1)
  },
  icon: {
    width: theme.spacing(4),
    height: theme.spacing(4)
  },
  groupButton: {
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0.75, 1)
    }
  },
  badgeAnchor: {
    transform: 'scale(1) translate(-10%, 10%)'
  },
  badgeColor: {
    backgroundColor: '#1C9DE8'
  }
})

const StyledButton = withStyles(theme => ({
  contained: {
    backgroundColor: '#fff',
    color: '#111112'
  },
  label: {
    fontSize: theme.spacing(1.5),
    lineHeight: theme.spacing(2) + 'px',
    fontWeight: '500',
    whiteSpace: 'nowrap'
  }
}))(Button);

class Header extends PureComponent {
  state = {
    mode: 'training',
    showAllChecked: false,
    cryptoChecked: true,
    commoditiesChecked: false,
    stockChecked: true,
    indexChecked: false,
    currencyChecked: false
  }

  render() {
    return (
      <AppBar position="fixed" className={this.props.classes.root}>
        <Toolbar>
          <Box flexGrow={1}>
            <IconButton
              edge="start"
              className={this.props.classes.button}
              onClick={this.props.onMenuClicked}
            >
              <img alt="" src={require('../assets/images/logo.svg')} className={this.props.classes.icon} />
            </IconButton>
            <ButtonGroup>
              <StyledButton
                className={this.props.classes.groupButton}
                onClick={() => this.setState({ mode: 'training' })}
                variant={this.state.mode === 'training' && 'contained'}
              >
                Training Mode
              </StyledButton>
              <StyledButton
                className={this.props.classes.groupButton}
                onClick={() => this.setState({ mode: 'live' })}
                variant={this.state.mode === 'live' && 'contained'}
              >
                Live Mode
              </StyledButton>
            </ButtonGroup>
          </Box>
          <Box display={{ xs: 'none', md: 'block' }}>
            <StyledButton
              className={this.props.classes.button}
              onClick={() => this.setState({ showAllChecked: !this.state.showAllChecked })}
              variant={this.state.showAllChecked ? 'contained' : 'outlined'}
            >
              Show All
            </StyledButton>
            <StyledButton
              className={this.props.classes.button}
              onClick={() => this.setState({ cryptoChecked: !this.state.cryptoChecked })}
              variant={this.state.cryptoChecked ? 'contained' : 'outlined'}
            >
              Crypto
            </StyledButton>
            <StyledButton
              className={this.props.classes.button}
              onClick={() => this.setState({ commoditiesChecked: !this.state.commoditiesChecked })}
              variant={this.state.commoditiesChecked ? 'contained' : 'outlined'}
            >
              Commodities
            </StyledButton>
            <StyledButton
              className={this.props.classes.button}
              onClick={() => this.setState({ stockChecked: !this.state.stockChecked })}
              variant={this.state.stockChecked ? 'contained' : 'outlined'}
            >
              Stock
            </StyledButton>
            <StyledButton
              className={this.props.classes.button}
              onClick={() => this.setState({ indexChecked: !this.state.indexChecked })}
              variant={this.state.indexChecked ? 'contained' : 'outlined'}
            >
              Index
            </StyledButton>
            <StyledButton
              onClick={() => this.setState({ currencyChecked: !this.state.currencyChecked })}
              variant={this.state.currencyChecked ? 'contained' : 'outlined'}
            >
              Currency
            </StyledButton>
          </Box>
          <Box textAlign="right" flexGrow={1} display={{ xs: 'none', sm: 'block' }}>
            <IconButton
              edge="start"
              className={this.props.classes.button}
            >
              <FiSearch fontSize={this.props.theme.spacing(3)} opacity={0.6} />
            </IconButton>
            <IconButton
              edge="start"
              className={this.props.classes.button}
            >
              <FiStar fontSize={this.props.theme.spacing(3)} opacity={0.6} />
            </IconButton>
            <IconButton
              edge="start"
              className={this.props.classes.button}
            >
              <IoSchoolOutline fontSize={this.props.theme.spacing(3)} opacity={0.6} />
            </IconButton>
          </Box>
          <Badge badgeContent={12} color="primary" classes={{
            anchorOriginTopRightRectangle: this.props.classes.badgeAnchor,
            colorPrimary: this.props.classes.badgeColor,
            colorSecondary: this.props.classes.badgeColor,
            colorError: this.props.classes.badgeColor
          }}>
            <IconButton edge="start">
              <img alt="" src={require('../assets/images/user-avatar.png')} className={this.props.classes.icon} />
            </IconButton>
          </Badge>
        </Toolbar>
      </AppBar>
    );
  }
}

Header.propTypes = {
  onMenuClicked: PropTypes.func.isRequired
};

export default compose(
  withStyles(styles, { withTheme: true }),
  withWidth()
)(Header);
